import React, { useState, useEffect } from "react";
import background from "../images/img5.jpg";
import Card from "../card/Cards";
import "./Home.css";
import Aos from "aos";
import "aos/dist/aos.css";
import CovidProject from "../images/covid.png";
import aiProject from "../images/ai.png";
import cNamibiaProject from "../images/cnamibia.png";
import minds from "../images/minds.png";
import iclean from "../images/iclean.png";
import marlo from "../images/marlo.png";
import binary from "../images/binary.png";
import game from "../images/game.png";

import {
  AiFillPhone,
  AiOutlineMail,
  FaFacebook,
  AiFillTwitterCircle,
  FiInstagram,
  SiLinkedin,
} from "react-icons/all";

export default function Home() {
  useEffect(() => {
    Aos.init({
      duration: 3000,
    });
  }, []);

  const [click, setClick] = useState(false);
  const [navbar, setNavbar] = useState(false);
  const handleClick = () => setClick(!click);

  const changeBackground = () => {
    if (window.scrollY >= 60) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  //projects array
  const projects = [
    {
      image: cNamibiaProject,
      name: "Computing Namibia website",
      description:
        "This is my first(personal) website that i have developed, it's developed with HTML,CSS and Javascrip",
      link: "https://r0qjgmzhuzwhkdombz3gaa-on.drv.tw/www.computingnamibia.com/Index.html",
    },
    {
      image: minds,
      name: "Mindsinaction website",
      description:
        "First client's website developed using React JS framework as it's frontend and PHP as it's backend.",
      link: "https://mindsinaction.com.na/",
    },
    {
      image: game,
      name: "NUST Strategic plan game",
      description:
        "This is a nust strategic plan game, designed and developed using Godot game engine.",
      link: "https://github.com/EliphasA/RollBall-Game-v1.2.git",
    },

    {
      image: aiProject,
      name: "AI news application (Alon)",
      description:
        "This a React application that gives worldwide news by listening to a user's request using a microphone",
      link: "https://loving-hugle-94e438.netlify.app/",
    },

    {
      image: CovidProject,
      name: "Covid19 tracking app",
      description:
        "This is a React application that gives daily updates of all the countries in the world on Corona virus Pandemic.",

      link: "https://covid-19-tracker-67906.web.app/",
    },

    {
      image: binary,
      name: "MVC project",
      description:
        "This is a Model View Controller developed using PHP and it's using MySQL as it's database",
      link: "http://mvc-project.epizy.com/",
    },
    {
      image: iclean,
      name: "Advert System",
      description:
        "This is an advertisement system developed using PHP and it's using MySQL as it's database",
      link: "http://icleanwall.epizy.com/?i=2",
    },
    {
      image: marlo,
      name: "Marlo wedding website",
      description: "Wedding website developed using React js framework.",
      link: "https://marlo.cf/",
    },
  ];

  window.addEventListener("scroll", changeBackground);
  const year = new Date().getFullYear();

  return (
    <>
      <div
        style={{
          backgroundImage: `linear-gradient(rgba(25, 42, 86, 0.95),rgba(25, 42, 86, 0.4)),url(${background})`,
          width: "100%",
          height: "600px",
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <nav className={navbar ? "navbar active" : "navbar"}>
          <div className="nav-container">
            <div className="logo">
              <h1>Andreas E.S</h1>
            </div>
            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                <a href="#home">Home</a>
              </li>
              <li className="nav-item">
                <a href="#about">About</a>
              </li>
              <li className="nav-item">
                <a href="#projects">Projects</a>
              </li>
              <li className="nav-item">
                <a href="#contact">Contact</a>
              </li>
            </ul>
            <div className="nav-icon" onClick={handleClick}>
              <i className={click ? "fas fa-times" : "fas fa-bars"}></i>
            </div>
          </div>
        </nav>
        <div id="home" className="body-home">
          <h1 data-aos="zoom-in-down">Hi, i am Elifas. A Software Engineer</h1>
          <div className="home-btn">
            <button data-aos="zoom-out-up">
              <a href="#about">Know more about me</a>
            </button>
          </div>
        </div>
      </div>
      <section
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1500"
        id="about"
        className="about"
      >
        <h2>About me</h2>
        <div className="about-content">
          <p>
            Experienced Software Engineer with a demonstrated history of working
            in the computer software industry. Skilled in Analytical Skills,
            User Interface Design, Teamwork, Problem Solving, and Database
            Design. Strong engineering professional with a Bachelor's degree in
            Computer Science focused in Software Engineering from NUST Namibia.
          </p>
        </div>

        <div className="tech-skills">
          <h1>Technical Skills</h1>
          <div className="tech">
            <div className="languages">
              <h2>Programming Languages</h2>
              <ul>
                <li>Java</li>
                <li>C++</li>
                <li>Python</li>
                <li>JavaScript</li>
                <li>HTML</li>
                <li>CSS</li>
                <li>Dart</li>
                <li>PHP</li>
                <li>GDScript</li>
              </ul>
            </div>
            <div className="frameworks">
              <h2>Frameworks</h2>
              <ul>
                <li>React</li>
                <li>Django</li>
              </ul>
            </div>
            <div className="sdks">
              <h2>SDKs</h2>
              <ul>
                <li>Flutter</li>
              </ul>
            </div>
            <div className="databases">
              <h2>Databases</h2>
              <ul>
                <li>MSSQL</li>
                <li>MySQL</li>
                <li>SQLite</li>
                <li>Firebase</li>
                <li>Oracle</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="projects" className="projects">
        <h1>Projects</h1>
        <div className="card-cont">
          {projects.map((x, i) => {
            return (
              <div key={iclean} className="card" data-aos="zoom-in-down">
                <Card
                  image={x.image}
                  name={x.name}
                  description={x.description}
                  link={x.link}
                />
              </div>
            );
          })}
        </div>
      </section>
      <div className="clearfix"></div>
      <footer id="contact">
        <div className="content">
          <div className="contacts">
            <h2>Contacts</h2>

            <div className="cell">
              <a href="#home">
                <AiFillPhone />
              </a>{" "}
              <p> +26481 5893187</p>
            </div>
            <div className="mail">
              <a href="#home">
                <AiOutlineMail />
              </a>
              <p>
                <a href="#home">andreaselifashikongo1@gmail.com</a>
              </p>
            </div>
          </div>
          <div className="social">
            <h2>Connect with me on</h2>
            <div className="icons">
              <div className="icon">
                <a href="https://www.facebook.com/andreas.elifas.9/">
                  <FaFacebook />
                </a>
              </div>
              <div className="icon">
                <a href="https://twitter.com/shiko_elifas">
                  <AiFillTwitterCircle />
                </a>
              </div>
              <div className="icon">
                <a href="https://www.instagram.com/andrew_eliphas/?hl=en">
                  <FiInstagram />
                </a>
              </div>
              <div className="icon">
                <a href="https://www.linkedin.com/in/andreas-elifas-698122190/">
                  <SiLinkedin />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="line"></div>
        <div className="copyright">
          <p>Copyrighted © {year} | website developed by Andreas E.S</p>
        </div>
      </footer>
      <div class="a-social-b">
        <a href="https://www.facebook.com/andreas.elifas.9/">
          <i class="fab fa-facebook"></i>
        </a>
        <a href="https://twitter.com/shiko_elifas">
          <i class="fab fa-twitter"></i>
        </a>
        <a href="https://www.instagram.com/andrew_eliphas/?hl=en">
          <i class="fab fa-instagram"></i>
        </a>
        <a href="https://www.linkedin.com/in/andreas-elifas-698122190/">
          <i class="fa fa-linkedin"></i>
        </a>
      </div>
      {/* <!--Start of Tawk.to Script--> */}
    </>
  );
}
